/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `sensirion` - sensirion
 * * `longpath` - longpath
 * @export
 */
export const DataProviderEnum = {
    Sensirion: 'sensirion',
    Longpath: 'longpath'
} as const;
export type DataProviderEnum = typeof DataProviderEnum[keyof typeof DataProviderEnum];


export function instanceOfDataProviderEnum(value: any): boolean {
    for (const key in DataProviderEnum) {
        if (Object.prototype.hasOwnProperty.call(DataProviderEnum, key)) {
            if (DataProviderEnum[key as keyof typeof DataProviderEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DataProviderEnumFromJSON(json: any): DataProviderEnum {
    return DataProviderEnumFromJSONTyped(json, false);
}

export function DataProviderEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataProviderEnum {
    return json as DataProviderEnum;
}

export function DataProviderEnumToJSON(value?: DataProviderEnum | null): any {
    return value as any;
}

export function DataProviderEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): DataProviderEnum {
    return value as DataProviderEnum;
}

